// extracted by mini-css-extract-plugin
export default {"Content":"PopupDelete_Content__OMQv1"};